import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "fr", setLang: () => {}, t: {} });
export const useLang = () => useContext(LangContext);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
